import React from 'react'
import { Link } from '@inertiajs/react'
import { cn } from '@/lib/utils'

/**
 * The two Market Intelligence tabs. Overview is read daily by every role; Compset is where the
 * competitors, your listing and the comparison room are set up. Page navigation, so `<Link>`s in a
 * `<nav>`, never Radix Tabs.
 */
const TABS = [
  { value: 'overview', label: 'Overview', path: '' },
  { value: 'compset', label: 'Compset', path: '/compset' },
] as const

export type MarketTab = (typeof TABS)[number]['value']

interface MarketIntelligenceNavProps {
  /** The property's backend-served canonical path. */
  propertyBasePath: string
  activeTab: MarketTab
}

export default function MarketIntelligenceNav({ propertyBasePath, activeTab }: MarketIntelligenceNavProps) {
  const base = `${propertyBasePath}/market-intelligence`

  return (
    <nav
      aria-label="Market Intelligence"
      className="animate-slide-in inline-flex h-10 items-center rounded-md bg-muted p-1 text-muted-foreground"
      style={{ animationDelay: '50ms' }}
    >
      {TABS.map((tab) => (
        <Link
          key={tab.value}
          href={`${base}${tab.path}`}
          aria-current={activeTab === tab.value ? 'page' : undefined}
          className={cn(
            'inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
            activeTab === tab.value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  )
}
